<template>
  <div class="accommodation-params">
    <el-row>
      <el-col :span="12">
        {{ $t("app.firstSemesterBeginDate") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.firstSemesterBeginDate"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.secondSemesterBeginDate") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.secondSemesterBeginDate"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.checkOutDateOfTheFirstSemester") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.dateFirst"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.checkOutDateOfTheSecondSemester") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.dateSecond"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.oldStuStartDate") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.oldStuStartDate"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.oldStuEndDate") }}:
        <el-date-picker
          size="small"
          v-model="childrenData.oldStuEndDate"
          type="datetime"
          :placeholder="$t('app.validation.date')"
          default-time="23:59:59"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.newStuStartDate") }}:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.newStuStartDate"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.newStuEndDate") }}:
        <el-date-picker
          size="small"
          v-model="childrenData.newStuEndDate"
          type="datetime"
          :placeholder="$t('app.validation.date')"
          default-time="23:59:59"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        {{ $t("app.schoolYear") }}:
        <el-input size="small" style="width: 200px;" v-model="childrenData.schoolYear" placeholder="2001"></el-input>
      </el-col>
      <el-col :span="12">
        {{ $t("app.semester") }}:
        <el-input style="width: 200px;" size="small" width="150" v-model="childrenData.semester" placeholder="1"></el-input>
      </el-col>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          oldStuStartDate: "",
          oldStuEndDate: "",
          newStuStartDate: "",
          newStuEndDate: "",
          dateFirst: "",
          dateSecond: "",
          firstSemesterBeginDate: "",
          secondSemesterBeginDate: "",
          schoolYear: '',
          semester: '',
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    reset() {
      this.childrenData.oldStuStartDate = "";
      this.childrenData.oldStuEndDate = "";
      this.childrenData.newStuStartDate = "";
      this.childrenData.newStuEndDate = "";
      this.childrenData.dateFirst = "";
      this.childrenData.dateSecond = "";
      this.childrenData.firstSemesterBeginDate = "";
      this.childrenData.secondSemesterBeginDate = "";
      this.childrenData.schoolYear = "";
      this.childrenData.semester = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.accommodation-params {
  min-height: 250px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
